module.exports = __webpack_public_path__ + "static/media/validation_formulaire.61f177d3.svg";